import React from "react";
import Cur from "./Cur";
import Prev from "./Prev";

export default function Viewbookpage() {
  return (
    <>
      <div className="view_booking_main_div">
        <div className="view_cur">
          <Cur />
        </div>
        <div className="view_prev">
          <Prev />
        </div>
      </div>
    </>
  );
}
